/* eslint-disable */
import Vue from 'vue'
import CryptoJS from 'crypto-js'
export default {


    encrypt (word, keyStr) { 

    var key = CryptoJS.enc.Utf8.parse(keyStr)

    var srcs = CryptoJS.enc.Utf8.parse(word)

    var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7}) 

    return encrypted.toString()

    },

    decrypt (word, keyStr) { 

    var key = CryptoJS.enc.Utf8.parse(keyStr)

    var decrypt = CryptoJS.AES.decrypt(word, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7})

    return CryptoJS.enc.Utf8.stringify(decrypt).toString()

    },

    // 截取url后面携带的参数
    splitUrlParam() {
        const urlStr = window.location.href
        const urlObj = {}
        // 检查url中是否携带数据
        if (urlStr.indexOf('?') === -1) return null
        // 找到 '?' 对应的下标
        const index = urlStr.indexOf('?') // index = 31
        // 截取 '?' 后的内容
        const dataStr = urlStr.substr(index + 1) // dataStr = a=1&b=2&c=&d=xxx&e
        // 通过 '&' 将字符串分割成数组
        const dataArr = dataStr.split('&') // ['a=1', 'b=2', 'c=', 'd=xxx', 'e']
        // 遍历字符串分割后的数组
        dataArr.forEach(str => {
            // 判断数组内的字符串是否有 '='
            if (str.indexOf('=') === -1) {
            // 如没有 '=' , 则将此字符串作为对象内键值对的键, 键值对的值为 undefined
            urlObj[str] = undefined // { e: undefined }
            } else {
            // 如果有 '='
            // 通过 '=' 将此字符串截取成两段字符串（不推荐使用 split 分割, 因为数据中可能携带多个 '=' ）
            const innerArrIndex = str.indexOf('=')
            const key = str.substring(0, innerArrIndex)
            const value = str.substr(innerArrIndex + 1)
            // 以截取后的两段字符串作为对象的键值对
            urlObj[key] = value // {a: '1', b: '2', c: '', d: 'xxx'}
            }
        })
        // 返回对象
        return urlObj
    }

}



// WEBPACK FOOTER //
// ./src/common/utils.js